import request from '@/router/axios';

export const getList = (current, size) => {
    return request({
        url: '/api/sino-winLot/winLot/cmsPageCommission',
        method: 'get',
        params: {
            current,
            size,
        }
    })
}
/**
 * 获取竞买人同一个拍卖会的成交标的详情
 * @param id
 */
export const getdetailCommission = (id) => {
    return request({
        url: '/api/sino-biz/meetingStatement/detail',
        method: 'get',
        params: {
            id
        }
    })
}
/**
 * 获取竞买人退款状态
 * @param id
 */
export const getRefundStatus = (id) => {
    return request({
        url: '/api/sino-biz/meetingStatement/getRefundStatus',
        method: 'get',
        params: {
            id
        }
    })
}
/**
 * 获取竞买人同一个拍卖会的成交标的列表
 * @param current
 * @param size
 * @param params
 */
export const getListCommission = (current, size, params) => {
    return request({
        url: '/api/sino-biz/meetingStatement//listMine',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}

export const detailCommission = (id) => {
    return request({
        url: '/api/sino-winLot/winLot/detailCommission',
        method: 'get',
        params: {
            id
        }
    })
}

export const payCommission = (row) => {
    return request({
        url: '/api/sino-winLot/winLot/payCommission',
        method: 'post',
        data: row
    })
}
/**
 * 结算款提交
 */
export const payTotal = (row) => {
    return request({
        url: '/api/sino-biz/meetingStatement/payTotal',
        method: 'post',
        data: row
    })
}

export const getCommissionRecord = (params) => {
    return request({
        url: '/api/sino-winLot/winLot/getCommissionRecord',
        method: 'get',
        params: params
    })
}

export const getCmsPlatformPage = (current, size, params) => {
    return request({
        url: '/api/sino-winLot/winLot/cmsPlatformPage',
        method: 'get',
        params: {
            ...params,
            current,
            size
        }
    })
}

export const cmcGetCommission = (id) => {
    return request({
        url: '/api/sino-winLot/winLot/cmcGetCommission',
        method: 'get',
        params: {
            id
        }
    })
}

export const cmsPagePlatformPrice = (current, size, params) => {
    return request({
        url: '/api/sino-winLot/winLot/cmsPagePlatformPrice',
        method: 'get',
        params: {
            ...params,
            current,
            size
        }
    })
}
/**
 * 获取竞买人中标标的列表
 */
export const winlotpage = (current, size, params) => {
    return request({
        url: '/api/sino-winLot/winLot/page',
        method: 'get',
        params: {
            ...params,
            current,
            size
        }
    })
}

export const payPlatformPrice = (id) => {
    return request({
        url: '/api/sino-winLot/winLot/payPlatformPrice',
        method: 'post',
        params: {
            id
        }
    })
}
